import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { conversationLogAPI } from "api/Interactions/ConversationsAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface ConversationsBottomDrawerProps {
  conversationId: number;
}

const ConversationsBottomDrawer: React.FC<ConversationsBottomDrawerProps> = ({ conversationId }) => {
  const fetchLogs = useCallback(() => conversationLogAPI.getAllByParentId(conversationId), [conversationId]);

  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp", type: "datetime"},
    { field: "first_name", label: "First Name", type: "text" },
    { field: "last_name", label: "Last Name", type: "text" },
    { field: "notes", label: "Subject", type: "text" },
  ];
  
  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Conversation Logs"
    />
  );
};

export default ConversationsBottomDrawer;
